import React from 'react';
import _ from 'lodash';
import StandardGlobals from './StandardGlobals';
import { useUnderwriterContext } from '../../views/underwriter/provider/UnderwriterProvider';
import RaterAggregateGlobals from './RaterAggregateGlobals';

interface GlobalComponentFactoryProps {
  /** Product version, or the related-quotes list, placed before the globals. */
  readonly leading?: React.ReactNode;
}

const GlobalComponentFactory = ({ leading }: GlobalComponentFactoryProps) => {
  const context = useUnderwriterContext();

  if (
    context.state.raterX.components &&
    !_.isEmpty(context.state.raterX.components)
  ) {
    return <RaterAggregateGlobals leading={leading} />;
  }

  return <StandardGlobals leading={leading} />;
};

export default GlobalComponentFactory;
